import ThemeSelector from './ThemeSelector';
export default ThemeSelector;
//# sourceMappingURL=index.js.map